export const LINE_CHART_COLOR_FILL = 'Line Chart Color Fill';
